import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Typography, Radio } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { users } from '../mockData';

const { Title } = Typography;

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);

  const handleLogin = (values) => {
    setLoading(true);
    
    // 模拟登录请求
    setTimeout(() => {
      const foundUser = users.find(
        user => user.username === values.username && user.password === values.password
      );
      
      if (foundUser) {
        message.success('登录成功');
        onLogin(foundUser);
      } else {
        message.error('用户名或密码错误');
      }
      setLoading(false);
    }, 1000);
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: '#f0f2f5'
    }}>
      <Card style={{ width: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2}>会员管理系统</Title>
        </div>
        
        <Form
          name="login"
          initialValues={{ remember: true }}
          onFinish={handleLogin}
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="用户名" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
            />
          </Form.Item>

          <Form.Item>
            <Radio.Group defaultValue="boss" buttonStyle="solid" style={{ marginBottom: 16 }}>
              <Radio.Button value="boss">老板账号</Radio.Button>
              <Radio.Button value="manager1">店长账号</Radio.Button>
              <Radio.Button value="staff1">员工账号</Radio.Button>
            </Radio.Group>
            <div style={{ color: '#999', marginBottom: 16, fontSize: 13 }}>
              选择账号类型，默认密码: 123456
            </div>
            <Button 
              type="primary" 
              htmlType="submit" 
              style={{ width: '100%' }}
              loading={loading}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login; 